
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { store } from '@/store'
import {
  queryTotalIntegral,
  queryPortraitTempUserTotal,
  queryTotalPortraitLight, queryPortraitModule
} from '@/apis/portrait'
import { formatDate, getPreMonth, setQueryConfig, setSession } from '@/utils'
import { PortaitMutationTypes } from '@/store/modules/portait/mutation-types'
import { parseImgUrl } from '@/utils'

export default defineComponent({
  components: {},
  setup() {
    let router = useRouter()
    let energyData: {
      intergral: any
      level: any
      totalPoints: number
    } = {
      intergral: 0,
      level: 0,
      totalPoints: 0
    }
    let arr: any = [
      {
        id: 'airConditioner',
        name: '空调调节',
        isShow: true,
        num: '--',
        unit: '',
        img: parseImgUrl('page-portrait', 'portrait_air.svg'),
      },
      {
        id: 'light',
        name: '开关照明',
        isShow: true,
        num: '--',
        unit: '',
        img: parseImgUrl('page-portrait', 'portrait_lamp.svg'),
      }
    ]
    const proxyData = reactive({
      parseImgUrl: parseImgUrl,
      user: store.state.user,
      energyData: energyData,
      energyArr: arr,
      goEnergyDetail(type: any) {
        router.push({
          path: `/energy-savig`,
          query: { type: type }
        })
      },
      dealNumToPoint(num: any, arrIndex: any) {
        if (!isNaN(num)) {
          if (num && num >= 10000) {
            num = Math.floor(num / 10000 * 10) / 10
            proxyData.energyArr[arrIndex].unit = '万'
          } else {
            proxyData.energyArr[arrIndex].unit = ''
            return num
          }
          return num ? num : '--'
        } else {
          return '--'
        }
      },
      /**
       * 节能分数
       */
      queryTotalIntegral() {
        let today = formatDate('')
        let lastMonth = getPreMonth()
        let params: any = {
          date: today,
          month: lastMonth
        }
        let query: string = setQueryConfig(params)
        queryTotalIntegral(query).then(function(res) {
          const resData: any = res
          if (res.result === 'success') {
            proxyData.energyData = resData
          }
        })
      },
      /**
       * 空调使用统计
       */
      queryPortraitTempUserTotal() {
        queryPortraitTempUserTotal().then(res => {
          const resData: any = res
          if (resData.result === 'success') {
            const data: any = resData?.data ?? null
            proxyData.energyArr[0].num = data ? proxyData.dealNumToPoint(data.adjustDownNum + data.adjustUpNum, 0) : '--'
          } else {
            proxyData.energyArr[0].num = '--'
          }
        })
      },
      /**
       * 照明使用统计
       */
      queryTotalPortraitLight() {
        queryTotalPortraitLight().then(res => {
          const resData: any = res
          if (resData.result === 'success') {
            const data: any = resData?.data ?? null
            proxyData.energyArr[1].num = data ? proxyData.dealNumToPoint(data.totalNum, 1) : '--'
          } else {
            proxyData.energyArr[1].num = '--'
          }
        })
      },
      /**
       * 判断设备统计数据的显示和隐藏
       */
      queryPortraitModule() {
        queryPortraitModule().then(res => {
          let resData: any = res
          let data = resData?.data ?? []
          // 判断模块的显示和隐藏
          proxyData.energyArr.forEach(function(item: any) {
            if (data.indexOf(item.id) > -1) {
              item.isshow = true
            } else {
              item.isshow = false
            }
          })
          /**
           * 缓层数据供后面子页面模块判断使用
           */
          let portraitModule: any = {
            airConditioner: false,
            light: false
          }
          if (data.indexOf('airConditioner') > -1) {
            portraitModule.airConditioner = true
          } else {
            portraitModule.airConditioner = false
          }
          if (data.indexOf('light') > -1) {
            portraitModule.light = true
          } else {
            portraitModule.light = false
          }
          setSession('portraitModule', portraitModule)
          store.commit(PortaitMutationTypes.SET_AIR, portraitModule.airConditioner)
          store.commit(PortaitMutationTypes.SET_LIGHT, portraitModule.light)
        })
      }
    })
    onMounted(() => {
      proxyData.queryPortraitModule()
      proxyData.queryTotalIntegral()
      proxyData.queryPortraitTempUserTotal()
      proxyData.queryTotalPortraitLight()
    })
    return {
      ...toRefs(proxyData)
    }
  }
})
